import script from "./ConfigEmpresaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigEmpresaPage.vue?vue&type=script&setup=true&lang=js"

import "./ConfigEmpresaPage.vue?vue&type=style&index=0&id=68671eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68671eb6"]])

export default __exports__